<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'
import rpApi from '@/services/api/rp.api'
const semesters = Object.freeze({ FirstSemester: 1, SecondSemester: 2 })
export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Reporte Registro de Visitas Remedio Provisional',
      routes: ['Informes', 'Reporte Registro de Visitas Remedio Provisional'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          months: [],
          providers: [],
        },
        filters: {
          academicYear: null,
          semester: null,
          month: null,
          provider: null,
        },
      },
    },
  }),
  computed: {
    isProviderFilterDisabled() {
      return (
        this.model.search.collections.providers?.length > 0 &&
        this.model.search.collections.providers?.some((x) => x.selected)
      )
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'semester',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Semestre',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-4',
          options: [
            { id: 1, name: 'Primer semestre' },
            { id: 2, name: 'Segundo semestre' },
          ],
          value: this.model.search.filters.semester,
          onChanged: this.onSemesterChanged,
          error: 'El semestre es requerido.',
          validations: 'required',
        },

        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          clearable: false,
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
          class: 'col-md-4',
          disabled: this.model.search.collections.months.length <= 0,
          onChanged: this.onChangeMonth,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-6',
          disabled:
            this.isProviderFilterDisabled ||
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async getProviders() {
      await rpApi
        .getProvidersWithVisits(
          this.model.search.filters.academicYear.id,
          this.model.search.filters.semester?.id,
          this.model.search.filters.month?.id
        )
        .then((res) => {
          this.model.search.collections.providers = res.data
          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
          } else if (res.data.length > 0) {
            const providerSelected = res.data?.find((x) => x?.selected)
            if (providerSelected) {
              this.model.search.filters.provider = providerSelected
            }
          }
        })
    },
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data

      if (this.model.search.collections.academicYears.length > 0) {
        this.model.search.filters.academicYear = this.model.search.collections.academicYears[0]
      }

      await this.onChangeAcademicYear()
    },
    async onChangeAcademicYear() {
      this.model.search.filters.month = null
      if (this.model.search.filters.semester !== null) {
        await this.onSemesterChanged()
        this.model.search.filters.provider = null
        this.model.search.collections.providers = []
        await this.getProviders()
      }
    },
    async onSemesterChanged() {
      await this.getMonth()
      await this.getProviders()
    },
    async onChangeMonth() {
      await this.getProviders()
    },
    async onHandlerSearch() {
      this.process()
    },
    async getMonth() {
      var months = (
        await AcademicYearServices.getMonthsInAcademicYear(
          this.model.search.filters.academicYear.id
        )
      ).data
      if (this.model.search.filters.semester.id === semesters.FirstSemester) {
        this.model.search.collections.months = months.filter(
          (x) => x.id >= 7 && x.id <= 12
        )
      } else {
        this.model.search.collections.months = months.filter(
          (x) => x.id >= 1 && x.id <= 6
        )
      }
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }
      await ReportServices.getReport('rpVisits', {
        academicYearId: this.model.search.filters.academicYear?.id,
        semester: this.model.search.filters.semester?.id,
        month: this.model.search.filters.month?.id,
        companyId: this.model.search.filters.provider?.id,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
